// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/model/disabled_track.proto (package knop.ui.v1.model, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message knop.ui.v1.model.DisabledTrack
 */
export class DisabledTrack extends Message<DisabledTrack> {
  /**
   * @generated from field: string track_code = 1;
   */
  trackCode = "";

  /**
   * @generated from field: knop.ui.v1.model.DisabledTrack.DisabledTrackType type = 2;
   */
  type = DisabledTrack_DisabledTrackType.UNKNOWN;

  constructor(data?: PartialMessage<DisabledTrack>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.DisabledTrack";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "track_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(DisabledTrack_DisabledTrackType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DisabledTrack {
    return new DisabledTrack().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DisabledTrack {
    return new DisabledTrack().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DisabledTrack {
    return new DisabledTrack().fromJsonString(jsonString, options);
  }

  static equals(a: DisabledTrack | PlainMessage<DisabledTrack> | undefined, b: DisabledTrack | PlainMessage<DisabledTrack> | undefined): boolean {
    return proto3.util.equals(DisabledTrack, a, b);
  }
}

/**
 * @generated from enum knop.ui.v1.model.DisabledTrack.DisabledTrackType
 */
export enum DisabledTrack_DisabledTrackType {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: NO_POWER = 1;
   */
  NO_POWER = 1,

  /**
   * @generated from enum value: NO_MOVE_NO_MATERIAL = 2;
   */
  NO_MOVE_NO_MATERIAL = 2,

  /**
   * @generated from enum value: NO_MOVE = 3;
   */
  NO_MOVE = 3,

  /**
   * @generated from enum value: NO_MOVE_NO_POWER = 4;
   */
  NO_MOVE_NO_POWER = 4,

  /**
   * @generated from enum value: RESERVATION = 5;
   */
  RESERVATION = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(DisabledTrack_DisabledTrackType)
proto3.util.setEnumType(DisabledTrack_DisabledTrackType, "knop.ui.v1.model.DisabledTrack.DisabledTrackType", [
  { no: 0, name: "UNKNOWN" },
  { no: 1, name: "NO_POWER" },
  { no: 2, name: "NO_MOVE_NO_MATERIAL" },
  { no: 3, name: "NO_MOVE" },
  { no: 4, name: "NO_MOVE_NO_POWER" },
  { no: 5, name: "RESERVATION" },
]);

